<template>
  <v-app>
    <v-app-bar
            color="cyan darken-1"
            dense
            dark
            app
    >
      <v-btn
              icon
              :to="{name: 'Home'}"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>

      <v-toolbar-title>LOKL</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text
             :to="{name: 'Promos'}">
        Promos
      </v-btn>

      <v-btn text
             :to="{name: 'Explain'}">
        How it Works
      </v-btn>

      <v-btn text
             :to="{name: 'Contact'}">
        Contact
      </v-btn>


    </v-app-bar>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>


export default {
  name: "App",
  data: () => ({
  //
  }),
};
</script>
